import { render, staticRenderFns } from "./ServiceUtilize.vue?vue&type=template&id=945a58cc&scoped=true"
import script from "./ServiceUtilize.vue?vue&type=script&lang=js"
export * from "./ServiceUtilize.vue?vue&type=script&lang=js"
import style0 from "./ServiceUtilize.vue?vue&type=style&index=0&id=945a58cc&prod&lang=stylus&scoped=true"
import style1 from "./ServiceUtilize.vue?vue&type=style&index=1&id=945a58cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945a58cc",
  null
  
)

export default component.exports